import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Alert,
  Link,
} from "@mui/joy";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../../store/authStore";

interface EmailSignInFormProps {
  onSuccess: () => void;
}

export const EmailSignInForm: React.FC<EmailSignInFormProps> = ({
  onSuccess,
}) => {
  const navigate = useNavigate();
  const { signIn, loading } = useAuthStore();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    try {
      await signIn(email, password);
      onSuccess();
    } catch (err) {
      setError((err as Error).message);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ textAlign: "left" }}>
      {error && (
        <Alert color="danger" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <FormControl sx={{ mb: 2 }}>
        <FormLabel>Email</FormLabel>
        <Input
          type="email"
          required
          placeholder="Your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </FormControl>

      <FormControl sx={{ mb: 1 }}>
        <FormLabel>Password</FormLabel>
        <Input
          type="password"
          required
          placeholder="Your password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </FormControl>

      <Box sx={{ textAlign: "right", mb: 2 }}>
        <Link
          component="button"
          type="button"
          level="body-sm"
          onClick={() => navigate("/auth/forgot-password")}
          sx={{ cursor: "pointer" }}
        >
          Forgot password?
        </Link>
      </Box>

      <Button
        type="submit"
        fullWidth
        loading={loading}
        sx={{
          backgroundColor: "#FF6B4A",
          "&:hover": { backgroundColor: "#E55A3A" },
        }}
      >
        Sign In
      </Button>
    </Box>
  );
};
